import React from "react";
import PhoneInput from "react-phone-number-input";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  phone: {
    display: "flex",
    alignItems: "center",

    "& .PhoneInputInput": {
      border: "none",
      outline: "none",
      fontFamily: "inherit",
      fontSize: "inherit",
      flex: 1,
      minWidth: 0,
    },
    "& .PhoneInputCountryIcon--square": {
      width: "1em",
    },
    "& .PhoneInputCountry": {
      position: "relative",
      alignSelf: "stretch",
      display: "flex",
      alignItems: "center",
      marginRight: "0.35em",
    },
    "& .PhoneInputCountrySelect": {
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      zIndex: 1,
      border: 0,
      opacity: 0,
      cursor: "pointer",
    },
    "& .PhoneInputCountrySelect:disabled": {
      cursor: "default",
    },
    "& .PhoneInputCountryIcon": {
      width: "calc(1em * 1.5)",
      height: "1em",
    },
    "& .PhoneInputCountryIcon--border": {
      backgroundColor: "rgba(0,0,0,0.1)",
      boxShadow: "0 0 0 1px rgba(0,0,0,0.5),inset 0 0 0 1px rgba(0,0,0,0.5)",
    },
    "& .PhoneInputCountryIconImg": {
      display: "block",
      width: "100%",
      height: "100%",
    },
    "& .PhoneInputInternationalIconPhone": {
      opacity: "0.8",
    },
    "& .PhoneInputInternationalIconGlobe": {
      opacity: "0.65",
    },
    "& .PhoneInputCountrySelectArrow": {
      display: "block",
      content: "",
      width: "0.3em",
      height: "0.3em",
      marginLeft: "0.35em",
      borderStyle: "solid",
      borderColor: "inherit",
      borderTopWidth: 0,
      borderBottomWidth: "1px",
      borderLeftWidth: 0,
      borderRightWidth: "1px",
      transform: "rotate(45deg)",
      opacity: "0.45",
    },
  },
}));

function PhoneInputComp({
  name = "phone",
  value,
  defaultCountry = "US",
  onChange,
  className,
}) {
  const classes = useStyles();
  return (
    <PhoneInput
      className={clsx(classes.phone, className)}
      name={name}
      value={value}
      placeholder="Enter phone number"
      defaultCountry={defaultCountry}
      onChange={onChange}
    />
  );
}

export default PhoneInputComp;
